export default __webpack_public_path__ + "static/media/samplePdf.d597a204.pdf";